// This file should never be imported from directly. Keep it out of the dependency graph,
// and use APIKeys-obfuscated.js instead.

import { isDev  } from '../utils/IsDev';
import { projectConfig } from '../project-info/projectConfig';
import { paymentConfig } from '../project-info/paymentConfig';

const env = isDev()
  ? 'staging' // set to 'dev'/'staging' for appropriate server
  : 'prod';

let stripeKey;
// for betas, make sure you use the productive stripe so real purchases can be tested
if (env !== 'prod') stripeKey = 'pk_test_51NMC1YI2CdhfFGKA6Dafn1vc7514tylobk7Df9ShLEB3JFfHyDkC7dRfvE9v2kLrukh9oIQkTBjJZuIiI3YmKk1I0036mBSeOU'; // retronyms test
else stripeKey = paymentConfig.stripeKey; // client specific live key

// This should be a client specific key, if there is none setup in paymentconfig we will use the default retronyms one
// Retronyms key is stored in Arjin's "Stripe" in the social stack account
export const STRIPE_KEY = stripeKey;

// Owned by retronyms, this is used to lookup address. In rwb we verify addresses, for social stack we do not.
// Accessed in 1pass, titled as "Melissa Data" and is Niki's information
// This key is for production and staging.
export const MELISSA_ID = 'IRrPJ2a5bvDsjWXUP36A_n**';

/* On the Google Cloud Console this key is limited to the following APIs:
  Geocoding API
  Places API
  Time Zone API
  Maps JavaScript API (web specific)
*/
// Currently one key handles all of these with no restrictions other than needing to use these apis
// TODO: Determine if we should break them down into individual keys/platforms for added security.
// We may want to split these keys up per project if want to accurately monitor and restrict keys.

// Main key for Places, Geocoding, Timezone, GCM, FCM, and more.
// Production & Staging. Owned by Retronyms. Managed in cloud console at Retronyms > Buddy Up.
export const GOOGLE_MAP_API_KEY = 'AIzaSyAJs2yORCYOG19wVN-uINAeinJ2ARhQkQw';

// if projectConfig hasOpenGraphPreviews is true, then this key is required.
let openGraphKey;
if (projectConfig.name == 'Design Bay Area') {
  // ***3431 "Design Bay Area" only. opengraph.io, Owned by Retronyms. Check 1Password for shared account, or request access from JP.
  openGraphKey = 'a4bd6755-0287-4585-97a6-72ea9a8d3431';
} else if (projectConfig.name == 'FitPros') {
  // ***0376 FitPros only. opengraph.io, Owned by Retronyms. Check 1Password for shared account, or request access from JP.
  openGraphKey = 'ac5eaa33-266b-428e-a146-bc9e36fb0376';
} else if (projectConfig.name == 'Buddy Up') {
   // ***e7a5 BuddyUp only. opengraph.io, Owned by Retronyms. Check 1Password for shared account, or request access from JP.
  openGraphKey = '94b22b01-b622-4e77-9764-4a0d9d6ce7a5';
} else {
  // ***a88e8 Retronyms development Open Graph Key. Check 1Password for shared account, or request access from JP.
  openGraphKey = '921a3193-8674-4c61-be12-b952f34a88e8';

}
export const OPENGRAPH_API_KEY = openGraphKey;

/* This is the project number from Firebase. This is needed to send pushes to android devices. It is NOT needed to send pushes to iOS devices. */
export const GCM_SENDER_ID = projectConfig.GCMSenderId;

/*
Needed for google signin on android.
First, add the release SHA-1 hash to the android app in Firebase Console ->
    Project Settings, then re-download the googleplay-services.json and put it in android/app

Second, navigate to Firebase Console -> Develop -> Authentication -> 
    Sign-in Method -> Google -> Web SDK Configuration (?) -> Google API Console.
    The (?) is the part you want to click in Web SDK Configuration.

    If it isn't already, ensure that the oauth consent screen is filled in correctly.

Third, in the same web-page, grab the `Web client (auto created by Google Service)` client id
    and paste it below in ANDROID_WEBCLIENT_ID
*/
const ANDROID_WEBCLIENT_ID =
  '248550484407-t4k3bquoioko2i16vs431sjvecc0ietn.apps.googleusercontent.com';

/*

*/
const WEBCLIENT_ID =
  '774546154193-i9a3e8u29dp72ihbmiam1jfjbgdqim5j.apps.googleusercontent.com';
/*

*/
const IOS_CLIENT_ID =
  '526930970232-7r2ctnfjt31qej2t0qukbfb0k19umk44.apps.googleusercontent.com';

export const GOOGLE_CLIENT_IDS = {
  android_webclient_id: ANDROID_WEBCLIENT_ID,
  webclient_id: WEBCLIENT_ID,
  ios_client_id: IOS_CLIENT_ID,
};

export const GOOGLE_REACT_API_KEY = 'AIzaSyBJIBLRIYN_Pa4IdFZ2aVPeAm9-dm29n0M';
